import { render, staticRenderFns } from "./BaseList.vue?vue&type=template&id=23f308da&scoped=true&"
import script from "./BaseList.vue?vue&type=script&lang=ts&setup=true&"
export * from "./BaseList.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./BaseList.vue?vue&type=style&index=0&id=23f308da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f308da",
  null
  
)

export default component.exports